import styled from 'styled-components'

const WorkforceContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

export {
  WorkforceContentWrapper,
}
